import Card from './Card';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const ColumnContent = ({
  columnData,
  shouldRenderCards
}) => {
  if (shouldRenderCards) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: columnData.cards.map((card, cardIndex) => /*#__PURE__*/_jsx("div", {
        "data-selenium-id": card.id,
        "data-test-id": "cdb-column-item",
        children: /*#__PURE__*/_jsx(Card, {
          index: cardIndex,
          cardData: card,
          columnData: columnData
        })
      }, card.id))
    });
  }
  return /*#__PURE__*/_jsx(LoadingSpinner, {
    layout: "centered",
    "data-test-id": "cdb-column-spinner"
  });
};
export default ColumnContent;